function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.424 19.644a1.045 1.045 0 001.883.865l4.105-6.569a2 2 0 011.696-.94H20.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5h-4.392a2 2 0 01-1.696-.94l-4.105-6.569a1.045 1.045 0 00-1.883.865l1.67 5.346A1 1 0 019.14 10H6a2 2 0 01-1.6-.8l-.654-.871a.822.822 0 00-1.447.718l.544 1.904a2 2 0 010 1.098l-.544 1.904a.822.822 0 001.447.718L4.4 13.8A2 2 0 016 13h3.14a1 1 0 01.954 1.298l-1.67 5.346z"
});

var SvgIconFlight = function SvgIconFlight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconFlight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-flight.b4e35e73.svg";
export { ForwardRef as ReactComponent };